import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { showMessageToast } from "components/toasts/MessageToast";
import { showSingleButtonToast } from "components/toasts/SingleButtonToast";
import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import {
  captureEvent,
  extractErrorProperties,
} from "context/posthog/captureEvent";
import { POSTHOG_EVENTS } from "context/posthog/events";
import {
  clearLastMutationError,
  getLastMutationError,
} from "store/lastMutationErrorMiddleware";

import type { ReactNode } from "react";

export interface UseSomethingWentWrongToastButtonOptions {
  buttonText: ReactNode;
  handleClick: () => void;
}

export function useSomethingWentWrongToast(
  isError: boolean,
  buttonOptions?: UseSomethingWentWrongToastButtonOptions,
  toastId?: string,
  error?: unknown
) {
  const { t } = useTranslation("common");
  const { buttonText, handleClick } = buttonOptions ?? {};
  const bodyContent = t(COMMON_TRANSLATION_KEYS.sorrySomethingWentWrong);

  useEffect(() => {
    if (!isError) {
      return;
    }

    const mutationError = error || getLastMutationError();

    if (mutationError) {
      captureEvent(POSTHOG_EVENTS.somethingWentWrongToastShown, {
        ...extractErrorProperties(mutationError),
      });
      clearLastMutationError();
    }

    if (buttonText && handleClick) {
      showSingleButtonToast({
        bodyContent,
        variant: "failure",
        buttonText: buttonText,
        handleClick: handleClick,
        config: { toastId },
      });

      return;
    }

    showMessageToast({
      bodyContent,
      variant: "failure",
      config: { toastId },
    });
  }, [isError, error, buttonText, handleClick, bodyContent, toastId]);
}
